import React from 'react';
import { Button, Grid } from '@mui/material';
import { Modalizer, FlexyHeaderForm } from '@europrocurement/flexy-components';
import { FlexyForm, FormStructure } from '@europrocurement/flexy-form';
import { FieldValues, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { AnyAction } from '@reduxjs/toolkit';
import {
    documentTypes,
    FormaliteDocument,
    FormalityAppDispatch,
    useFormaliteService,
} from '@europrocurement/l2d-domain';
import useDocumentTypeFormHandler from '../../hooks/useDocumentTypeFormHandler';
import {
    boolOptions,
    docStatusChoices,
    getBooleanField,
    getDocumentTypeMainFields,
} from '../documentTypeFormStructure';

type DocumentTypeEditModalProps = {
    documentType: FormaliteDocument;
    isOpen: boolean;
    onClose: () => void;
};

const DocumentTypeEditModal: React.FunctionComponent<DocumentTypeEditModalProps> = function (
    props,
) {
    const { documentType, isOpen, onClose } = props;
    const { selectFormaliteDocument } = useFormaliteService();
    const { handleEditForm, requestState } = useDocumentTypeFormHandler();
    const dispatch = useDispatch<FormalityAppDispatch>();

    const onSubmit = (formData: FieldValues) => {
        handleEditForm(documentType, formData).then(() => {
            dispatch(
                selectFormaliteDocument({ id: documentType.id as number }) as unknown as AnyAction,
            );
            onClose();
        });
    };

    const formStructure: FormStructure[] = [
        ...getDocumentTypeMainFields(),
        getBooleanField({
            name: 'vide',
            inputlabel: 'Document vide',
            placeholder: 'Document vide ?',
        }),
    ];

    const formContext = useForm<FieldValues>({
        mode: 'onTouched',
        defaultValues: {
            libelle: documentType?.libelle,
            name: documentType?.name,
            type: documentTypes.find((option) => option.value === documentType?.type),
            libelleDF: documentType?.libelleDF,
            help: documentType?.help,
            vide: boolOptions.find((option) => option.value === Boolean(documentType?.vide)),
            statut: docStatusChoices.find((option) => option.value === documentType?.statut),
        },
    });

    const formProps = {
        formContext,
        formObject: {},
        onSubmit,
        submitButton: {
            displayed: false,
        },
    };

    const submitBtn = (
        <Button
            key="document-type-edit-submit_button"
            color="primary"
            variant="contained"
            onClick={formContext.handleSubmit(onSubmit)}
            style={{ marginTop: '8px', marginBottom: '8px' }}
            disabled={requestState.isProcessing}
        >
            Enregistrer
        </Button>
    );
    const cancelBtn = (
        <Button
            key="document-type-edit-cancel_button"
            color="primary"
            variant="outlined"
            onClick={onClose}
            style={{ marginTop: '8px', marginBottom: '8px' }}
            disabled={requestState.isProcessing}
        >
            Annuler
        </Button>
    );

    return (
        <Modalizer
            open={isOpen}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            modalActions={[cancelBtn, submitBtn]}
        >
            <Grid>
                <FlexyHeaderForm
                    outlined
                    label="Modifier un type de document"
                />
                <FlexyForm
                    formStructure={formStructure}
                    {...formProps}
                />
            </Grid>
        </Modalizer>
    );
};

export default DocumentTypeEditModal;
